<template>
    <v-dialog v-model="dialogSwitch" persistent scrollable width="400">
        <v-form v-model="formData.valid" class="mb-3" validate-on="input" @submit.prevent="updateRecipient">
            <v-card>
                <v-card-title id="heading" class="d-flex justify-space-between">
                    <h4>Edit Recipient</h4>
                    <v-btn density="compact" icon="mdi-close" variant="flat" @click="$emit('update:modelValue',false)"/>
                </v-card-title>

                <v-container>
                    <v-alert v-if="errors.length" class="mb-3 bg-error" closable close-label="Close Alert"
                             density="compact" variant="tonal">
                        <p v-for="error in errors">{{ error }}</p>
                    </v-alert>
                    <v-row v-if="!recipient.type">
                        <v-col cols="12">
                            <p>{{ `${recipient.first_name} ${recipient.last_name}` }}</p>
                        </v-col>
                        <v-col sm="4">
                            <v-switch v-model="formData['app_enabled']" color="primary" density="compact" label="App"/>
                        </v-col>
                        <v-col sm="4">
                            <v-switch v-model="formData['email_enabled']" color="primary" density="compact"
                                      label="Email"/>
                        </v-col>
                        <v-col sm="4">
                            <v-switch v-model="formData['sms_enabled']" color="primary" density="compact" label="SMS"/>
                        </v-col>
                    </v-row>
                    <v-row v-else>
                        <v-col cols="12">
                            <v-radio-group v-model="thirdPartyType" color="primary" inline
                                           label="Select type of recipient" @update:modelValue="(value)=>{
                                                formData['recipient']=null;
                                                if(value === 'email'){
                                                    formData['sms_enabled']=false;
                                                    formData['email_enabled']=true;
                                                }else{
                                                    formData['sms_enabled']=true;
                                                    formData['email_enabled']=false;
                                                }
                                           }">
                                <v-radio label="Email" value="email"></v-radio>
                                <v-radio label="SMS" value="sms"></v-radio>
                            </v-radio-group>
                            <v-text-field v-model="formData['recipient']"
                                          :rules="[vRules.required,thirdPartyType === 'email'? vRules.email: vRules.numeric]"
                                          :type="thirdPartyType === 'email'?'email':'number'" density="compact"
                                          label="Recipient"/>
                        </v-col>
                    </v-row>
                </v-container>

                <v-card-actions class="px-4 d-flex justify-end">
                    <v-btn size="small" type="button" @click="$emit('update:modelValue',false)">
                        Close
                    </v-btn>
                    <v-btn :disabled="!formData.valid" color="primary" size="small" type="submit">Save</v-btn>
                </v-card-actions>
            </v-card>
        </v-form>
    </v-dialog>
</template>

<script setup>
import {ref, reactive, watch} from "vue";
import {send} from "@/composables/apiClient";
import {useSnackbarStore} from "@/stores/snackBarStore";

const errors = ref([]);
const snackbar = useSnackbarStore();
const props = defineProps({
    modelValue: Boolean,
    recipient: Object,
    group: Object,
});

const thirdPartyType = ref((props.recipient.type ? (props.recipient.email_enabled ? 'email' : 'sms') : null));
const dialogSwitch = ref(props.modelValue);
const formData = reactive({
    valid: false,
    type: props.recipient.type,
    user_id: props.recipient.user_id,
    app_enabled: !!props.recipient.app_enabled,
    sms_enabled: !!props.recipient.sms_enabled,
    email_enabled: !!props.recipient.email_enabled,
    recipient: (props.recipient.type ? (props.recipient.email ? props.recipient.email : props.recipient.sms) : null),
});
const emits = defineEmits(['update:modelValue', 'editMember']);

const updateRecipient = () => {
    errors.value = [];
    send('put', `monitoring/notification-group-members/${props.recipient.id}`, formData)
        .then((response) => {
            snackbar.showSnackbar(response.data.message);
            if (response.data.success) {
                emits('editMember', response.data.data.member);
                emits('update:modelValue', false);
            }
        })
        .catch(function (errorResponse) {
            if (errorResponse.response.data.errors) {
                let validationErrors = errorResponse.response.data.errors;
                Object.keys(validationErrors).forEach((key) => {
                    errors.value.push(validationErrors[key][0]);
                });
            } else if (errorResponse.response.data.message) {
                errors.value.push(errorResponse.response.data.message);
            }
            snackbar.showSnackbar('Something went wrong', 'error');
            document.getElementById('heading').scrollIntoView({behavior: 'smooth'});
        })
}

</script>